<div class="breadCrumb-container flex flex-wrap text-sm lg:overflow-hidden  overflow-scroll text-text">
  <ejs-tooltip target="#home" content="Home">
  <a (click)="redirect('/home',0)">
    <div id="home" class="flex  text-sm font-semibold cursor-pointer my-auto" ><i class="e-icons e-home stroke-1" style="font-size: 25px;"></i></div>
  </a>
  </ejs-tooltip>
  <span *ngIf="firstLoad" class="mx-1 "> {{divider}} </span>

    <div class="flex-row  justify-between flex align-middle "  *ngFor="let u of urls; last as last; first as first; index as index">
        <ejs-tooltip target="#elem{{index}}" [content]="u">
            <a id="elem{{index}}" (click)="redirect(u,index)">
                <!--<div class="flex" *ngIf="first"><i class="e-icons"></i></div>-->
                 <div *ngIf="u!='home' && !first " class="flex text-sm font-semibold cursor-pointer" >{{u | textShortener:20}}</div> 
                <!-- <div *ngIf="!first && index>1 && u=='home'" id="{{index}}-elem" class="flex text-gray-900 text-sm font-semibold cursor-pointer" >{{u}}</div> -->
            </a>
        </ejs-tooltip>
            <span *ngIf="index>0 && !last" class="mx-1 "> {{divider}} </span>
    </div>
</div>